import {gql} from '@apollo/client';
import {DocumentNode} from 'graphql';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

// This query is known to be slow (5-10 seconds), and fired on page load a few times - when querying, we split
// it from other data that components may need for two reasons:
//   1) So that we can avoid batching this query with any other queries going on (it'll slow them down)
//   2) Apollo Client will serve a query from cache if the entire query is present, otherwise it'll send the
//      entire query to the server. We want to avoid computing this multiple times.
// See UserMenu for an example.
export const ALL_SOURCES_QUERY: DocumentNode = gql`
  query AllSourcesQuery @skipAudit @engComponent(name: PROJECT_FOLDER) {
    ...AllSourcesGraphQL
  }
  ${getFragmentWrapper('AllSources').fragment}
`;
